module.exports = __webpack_public_path__ + "static/media/video.2cb4f676.mp4";